import { defineComponent as _defineComponent } from 'vue'
import { useAccordeon, useSocials } from '@/composables';

interface Props {
  value?: boolean;
  menu: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderMobileMenu',
  props: {
    value: { type: Boolean },
    menu: null
  },
  setup(__props: any) {



const { activeItem, setActiveItem } = useAccordeon();
const { socials } = useSocials();

return { __sfc: true,activeItem, setActiveItem, socials }
}

})